import { AgTechDialogContext, DialogContext } from "@agtech/core/forms/dialogs/AgTechDialogs";
import AgTechPortal, { useAgTechLayerCount } from "../../Portals/AgTechPortal";
import React, { PropsWithChildren, useEffect, useState } from "react";

export type AgTechDialogSlotProps = {
    id: string,
    closeDialog: () => void
}

let AgTechDialogSlotComponent = (props: PropsWithChildren<AgTechDialogSlotProps>) => {
    // let [isActive, setIsActive] = useState(false);
    let layerCount = useAgTechLayerCount();

    let dialogContext: AgTechDialogContext = {
        closeDialog: (e: React.MouseEvent<HTMLElement> | null) => {
            if (e) {
                e.stopPropagation();
            }

            props.closeDialog();
        }
    };

    // useEffect(() => {
    //     window.setTimeout(() => {
    //         setIsActive(true);
    //     }, 10);
    // }, []);

    return (
        // isActive ? (
            <AgTechPortal>
                <DialogContext.Provider value={dialogContext}>
                    <div
                        className="agtech-app-layer stretched relative non-scrollable container"
                        style={{ justifyContent: 'flex-end' }}
                        data-layer={layerCount.current + 1}
                    >
                        {props.children}
                    </div>
                </DialogContext.Provider>
            </AgTechPortal>
        // ) : null
    )
};

const AgTechDialogSlot = React.memo(AgTechDialogSlotComponent, (prev, curr) => prev.id === curr.id);

export default AgTechDialogSlot;